export default __webpack_public_path__ + "static/media/content_Loading-Loop-1.cc0a15fd.gif";